module.exports = __webpack_public_path__ + "media/images/icon/chevron-right-white-6128dceda272198372dde7068d355dd1.svg";